var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-tabs', {
    attrs: {
      "card": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Single Manual Entry"
    }
  }, [_c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "black-text"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Record Manual Delivery")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Shipping ID :")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    key: _vm.formKey,
    ref: "shippingInput",
    attrs: {
      "placeholder": "e.g., SHP123456789"
    },
    on: {
      "blur": _vm.fetchShippingAndUserDetails
    },
    model: {
      value: (_vm.ShippingID),
      callback: function($$v) {
        _vm.ShippingID = $$v
      },
      expression: "ShippingID"
    }
  })], 1), _vm._v(" "), (_vm.errors.ShippingID) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.ShippingID))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Delivery Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    key: _vm.formKey,
    attrs: {
      "id": "deliverydate",
      "name": "deliverydate",
      "type": "date",
      "disabled": _vm.deliveryDateDisabled
    },
    model: {
      value: (_vm.DeliveryDate),
      callback: function($$v) {
        _vm.DeliveryDate = $$v
      },
      expression: "DeliveryDate"
    }
  })], 1), _vm._v(" "), (_vm.errors.DeliveryDate) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.DeliveryDate))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 position-relative"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("SR EmployeeID :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearchText),
      expression: "userSearchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter EmployeeID"
    },
    domProps: {
      "value": (_vm.userSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearchText = $event.target.value
      }, _vm.filterUserIDs]
    }
  }), _vm._v(" "), (_vm.filteredUsers.length && _vm.userSearchText) ? _c('ul', {
    staticClass: "list-group position-absolute w-100",
    staticStyle: {
      "z-index": "1000",
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('li', {
      key: user.userid,
      staticClass: "list-group-item list-group-item-action",
      on: {
        "click": function($event) {
          _vm.selectUser(user)
        }
      }
    }, [_vm._v("\n        " + _vm._s(user.EmployeeID) + " - " + _vm._s(user.username) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), (_vm.errors.UserID) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.UserID))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("COD Amount (₹) :")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "number",
      "disabled": ""
    },
    model: {
      value: (_vm.CODAmount),
      callback: function($$v) {
        _vm.CODAmount = $$v
      },
      expression: "CODAmount"
    }
  })], 1), _vm._v(" "), (_vm.errors.CODAmount) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.CODAmount))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Penalty Amount (₹) (Optional) :")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    key: _vm.formKey,
    attrs: {
      "type": "number",
      "placeholder": "e.g., 100.00"
    },
    model: {
      value: (_vm.PenaltyAmount),
      callback: function($$v) {
        _vm.PenaltyAmount = $$v
      },
      expression: "PenaltyAmount"
    }
  })], 1), _vm._v(" "), (_vm.errors.PenaltyAmount) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.PenaltyAmount))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Recovery Status :")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.selectedRecoveryStatus === 'fully_recovered'
    },
    on: {
      "change": function($event) {
        _vm.handleCheckboxChange('fully_recovered')
      }
    }
  }, [_vm._v("\n          Recovered (Both shipment value + penalty value recovered)\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "checked": _vm.selectedRecoveryStatus === 'partial_recovered'
    },
    on: {
      "change": function($event) {
        _vm.handleCheckboxChange('partial_recovered')
      }
    }
  }, [_vm._v("\n          Recovered (Only shipment value recovered)\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "checked": _vm.selectedRecoveryStatus === 'not_recovered'
    },
    on: {
      "change": function($event) {
        _vm.handleCheckboxChange('not_recovered')
      }
    }
  }, [_vm._v("\n          Not Recovered\n        ")]), _vm._v(" "), (_vm.errors.selectedRecoveryStatus) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.selectedRecoveryStatus))]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.showBagCondition) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Recovery Details (Txn Ref / Debit Note):")]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "e.g., T123456789"
    },
    model: {
      value: (_vm.recoverydetails),
      callback: function($$v) {
        _vm.recoverydetails = $$v
      },
      expression: "recoverydetails"
    }
  })], 1), _vm._v(" "), (_vm.errors.recoverydetails) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.recoverydetails))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.showBagCondition) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Date of Deposit :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    key: _vm.formKey,
    attrs: {
      "id": "depositedate",
      "name": "depositedate",
      "type": "date"
    },
    model: {
      value: (_vm.depositedate),
      callback: function($$v) {
        _vm.depositedate = $$v
      },
      expression: "depositedate"
    }
  })], 1), _vm._v(" "), (_vm.errors.depositedate) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.depositedate))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.showBagCondition) ? _c('b-form-group', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "label": "XB Bank Account Name"
    }
  }, [_c('b-form-input', {
    key: _vm.formKey,
    attrs: {
      "id": "BankDetails",
      "name": "BankDetails",
      "placeholder": "e.g., ICICI Bank - 123456"
    },
    model: {
      value: (_vm.BankDetails),
      callback: function($$v) {
        _vm.BankDetails = $$v
      },
      expression: "BankDetails"
    }
  }), _vm._v(" "), (_vm.errors.BankDetails) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.errors.BankDetails))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.submitManualDelivery
    }
  }, [_vm._v("\n      Mark Shipment as Manually Delivered\n    ")])], 1)], 1)])])], 1)])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Bulk CSV Upload"
    }
  }, [_c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "black-text"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Bulk Dispute Upload")])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v("\n      Upload a CSV file with delivery details."), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Expected columns")]), _vm._v(" (header required): "), _c('code', [_vm._v("shippingId")]), _vm._v(", "), _c('code', [_vm._v("EmployeeID")]), _vm._v(", "), _c('code', [_vm._v("deliveryDate")]), _vm._v(" (YYYY-MM-DD), "), _c('code', [_vm._v("PenaltyAmount")]), _vm._v(", "), _c('code', [_vm._v("recoveryStatus")]), _vm._v(" (partial_recovered/fully_recovered/not_recovered), "), _c('code', [_vm._v("depositeDate")]), _vm._v(", "), _c('code', [_vm._v("BankDetails")]), _vm._v("."), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Optional columns")]), _vm._v(": "), _c('code', [_vm._v("recoveryDetails")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [(_vm.bulkLoader) ? _c('div', {
    staticClass: "card-loader-overlay"
  }, [_c('div', {
    staticClass: "card-loader-box"
  }, [_c('div', {
    staticClass: "loader-wrapper"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": true,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold mt-3 text-dark"
  }, [_vm._v("\n                CSV is being processed, please do not close or reload the webpage\n              ")])])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b-input-group', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File:",
      "description": "Allowed file types: .CSV",
      "label-cols": 3
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-info",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload and Process")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("\n    Download sample CSV file for upload\n     \n    "), _c('i', {
    staticClass: "fa fa-download downloadIcon",
    staticStyle: {
      "cursor": "pointer",
      "color": "black"
    },
    attrs: {
      "title": "Download csv format"
    },
    on: {
      "click": function($event) {
        _vm.downloadSampleCsv()
      }
    }
  })])]), _vm._v(" "), (_vm.bulkCSVDataFlag) ? _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "counts"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Failed: " + _vm._s(_vm.FailedRecords) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                Success: " + _vm._s(_vm.successData) + " ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show2,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#000080"
    }
  })], 1), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DeliveryDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("EmployeeID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("isRecovered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CodAmount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PenaltyAmount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("TransactionReferenceNumber")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DebitNoteNumber")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("fromHistoryTable")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("FailureReason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bulkCSVData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.EmployeeID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isRecovered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CodAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.PenaltyAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.TransactionReferenceNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DebitNoteNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fromHistoryTable))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FailureReason))])])
  }))])]), _c('br')], 1)]) : _vm._e()])])])], 1)])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef230d38","hasScoped":true}!./src/views/components/markManualDeliveryShipments/markManualDeliveryShipments.components.html
// module id = 495
// module chunks = 1